import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getTransferInbounds({ commit }, params = {}) {
    return axios.get('/transfer-inbounds/search', { params })
  },
  getTransferInbound({ commit }, id) {
    return axios.get(`/transfer-inbounds/${id}`)
  },
  createTransferInbound({ commit }, data) {
    return axios.post('/transfer-inbounds', data)
  },
  updateTransferInbound({ commit }, data) {
    return axios.put(`/transfer-inbounds/${data.id}`, data)
  },
  deleteTransferInbound({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/transfer-inbounds/${data.id}/delete`, data)
  },
  confirmReceived({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/received`, data)
  },
  downloadInBound({ commit }, data) {
    return axios
      .get(`/transfer-inbounds/${data.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${data.document_name}.pdf`)
      })
  },
  updateTransferInboundStatus({ commit }, data) {
    return axios.put(`/transfer-inbounds/${data.id}/change-status`, data)
  },
  sendTransferInbound({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/sending`, data.params)
  },
  rejectTransferintbound({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/rejected`, data.params)
  },
  cancellTransferintbound({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/cancelled`, data.params)
  },
  receiveTransferInbound({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/received`, data.params)
  },
  reorderTransferInbound({ commit }, data) {
    return axios.post(`/transfer-inbounds/${data.id}/reorder`, data.params)
  }
}
